export const StoritevEnum = {
  DEFAULT_CONNECTOR_MOBILE: '2',
  DEFAULT_CONNECTOR_TV2GO: '3',
  BREZ_TRZNEGA_PAKEGA: '201',
  _3_MESECNO_ODPLACILO_OBROKOV: '297',
  WIFI_STORITEV: 1090,
  _12_MESECNO_ODPLACILO_OBROKOV: '1125',
  _24_MESECNO_ODPLACILO_OBROKOV: '1126',
  NAJEM_WIFI_OPREME: 1438,
  _6_MESECNO_ODPLACILO_OBROKOV: '2298',
  _36_MESECNO_ODPLACILO_OBROKOV: '4683',
  NAJEM_WIFI_MESH_OPREME: 4708,
  NAJEM_WIFI_6_MASH_OPREME: 5884,
  APLIKACIJA_T2_TV: 5996,
  PANDA_DOME_ESSENTIAL: 4770,
  PANDA_DOME_COMPLETE: 4771,
  SCITMOB: 6285,
  SCITFIX: 6286,
  SCITPAKET: 6291,
  DODATEN_1GB_EMAIL: 1685,
  EMAIL_LASTNA_DOMENA: 426,
  STORITEV_5G: 6221,
  STORITEV_VOLTE: 6222
}



// WEBPACK FOOTER //
// ./src/assets/js/Enum/StoritevEnum.js